import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createElementVNode as _createElementVNode, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-9d701df6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "guild-content" }
const _hoisted_2 = { class: "settings" }
const _hoisted_3 = { class: "result-text" }

import {computed, onMounted, Ref, ref} from "vue";
import {useRoute} from "vue-router";
import {useStore} from "vuex";
import {SubmitResult} from "@/types/SubmitResult";
import {Guild} from "@/types/Guild";
import {GuildSettings} from "@/types/GuildSettings";


export default /*#__PURE__*/_defineComponent({
  __name: 'GuildView',
  setup(__props) {

const store = useStore();
const route = useRoute();
let guild = computed(() => (store.getters.guilds as Array<Guild>).find(g => g.id === route.params.id));
let snackbar = ref(false)
let success = ref(true)

onMounted(async () => {
  if (!guild.value?.settings) await store.dispatch('getGuild', route.params.id)
})

async function submitted(result: SubmitResult, settings?: GuildSettings) {
  success.value = result === 'success';
  if (result === 'success') await store.dispatch('updateSettings', {id: route.params.id, settings})
  snackbar.value = true;
}

return (_ctx: any,_cache: any) => {
  const _component_v_list_subheader = _resolveComponent("v-list-subheader")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_item_group = _resolveComponent("v-item-group")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_scroll_y_transition = _resolveComponent("v-scroll-y-transition")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_v_window = _resolveComponent("v-window")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_list, {
      class: "guild-menu",
      color: "primary",
      "bg-color": "mobileNav",
      elevation: "5"
    }, {
      default: _withCtx(() => [
        (!_unref(guild))
          ? (_openBlock(), _createBlock(_component_v_list_subheader, {
              key: 0,
              class: "guild-name"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Guild.loading')), 1)
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_v_list_subheader, {
              key: 1,
              class: "guild-name text-truncate"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(guild).name), 1)
              ]),
              _: 1
            })),
        _createVNode(_component_v_divider),
        _createVNode(_component_v_item_group, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$tm('Guild.links'), (link) => {
              return (_openBlock(), _createBlock(_component_v_list_item, {
                to: _ctx.$rt(link.path),
                "prepend-icon": _ctx.$rt(link.icon),
                "min-height": "55"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$rt(link.name)), 1)
                ]),
                _: 2
              }, 1032, ["to", "prepend-icon"]))
            }), 256))
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_window, { class: "guild-settings" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_router_view, null, {
            default: _withCtx(({ Component }) => [
              _createVNode(_component_v_scroll_y_transition, { duration: 100 }, {
                default: _withCtx(() => [
                  (!_unref(guild)?.settings)
                    ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                        key: 0,
                        class: "item-center",
                        size: 60,
                        width: 5,
                        indeterminate: ""
                      }))
                    : (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                        key: 1,
                        settings: _unref(guild).settings,
                        onSubmitted: submitted
                      }, null, 40, ["settings"]))
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          }),
          _createVNode(_component_v_snackbar, {
            modelValue: _unref(snackbar),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(snackbar) ? (snackbar).value = $event : snackbar = $event)),
            color: "block"
          }, {
            actions: _withCtx(() => [
              _createVNode(_component_v_btn, {
                color: _unref(success) ? 'green' : 'pink',
                variant: "text",
                ripple: "",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_isRef(snackbar) //@ts-ignore
 ? snackbar.value = false : snackbar = false))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Guild.close')), 1)
                ]),
                _: 1
              }, 8, ["color"])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(success) ? _ctx.$t('Guild.submitted') : _ctx.$t('Guild.error')), 1)
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})